import React from 'react';
import '../../styles/c_HomeFinancement.css';
import { useHomeData } from '../../hooks/useHomeData';

function HomeFinancement() {
    const { data } = useHomeData();
    const financementData = data?.financement;

    const highlightTerms = ['cadeau personnalisé', 'attention pour un proche', 'cadeau d\'entreprise', 'projet de financement'];
    const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const highlightRegex = new RegExp(
        `(${highlightTerms.map(escapeRegExp).join('|')})`,
        'gi'
    );

    const renderHighlighted = (text = '') =>
        text.split(highlightRegex).map((part, index) =>
            highlightTerms.some(t => t.toLowerCase() === part.toLowerCase()) ? (
                <span key={index} className="homeFinancementHighlight">{part}</span>
            ) : (
                <React.Fragment key={index}>{part}</React.Fragment>
            )
        );

    if (!financementData?.title) {
        return <div className="loadingFiller"></div>;
    }

    return (
        <>
            <div id='homeFinancementWrapper'>
                <div className="homeFinancementImage">
                    <img src={financementData.image.path} alt={financementData.image.alt} loading='lazy' decoding='async' />
                </div>
                <div className="homeFinancementContent">
                    <h2 className='homeFinancementTitle'><a href={financementData.button.href} target="_blank" rel="noreferrer">{financementData.title}</a></h2>
                    <p className='homeFinancementSubtitle'>{financementData.subtitle}</p>
                    <p className='homeFinancementDescription'>{renderHighlighted(financementData.description)}</p>
                    <p className='homeFinancementFeatures'>{renderHighlighted(financementData.features)}</p>
                    <a className='homeFinancementBtn' href={financementData.button.href} target="_blank" rel="noreferrer">{financementData.button.text}</a>
                </div>
            </div>
        </>
    );
}

export default HomeFinancement;
